export default __webpack_public_path__ + "static/media/question.686b1445.svg";